/**
 * Boundary validation for BQL responses — the BQL binding of the generic seam in
 * `shared/api/utils/contract.ts`, which owns the brand, the message shape and the
 * issue summary. Only the label and the error type are BQL's own.
 */
import {
	parseContract,
	ResponseContractError,
} from '@/shared/api/utils/contract'

import type { z } from 'zod'

/**
 * A BQL response that arrived intact but did not match the generated schema.
 *
 * A distinct type rather than the base class so BQL's own handlers and tests can name
 * it; the `_isContractError` brand `smartRetry` keys off is inherited.
 */
export class BqlContractError extends ResponseContractError {
	constructor(route: string, cause: z.ZodError) {
		super('BQL', route, cause)
		this.name = 'BqlContractError'
	}
}

/** Parse a BQL response body, raising a `BqlContractError` when it does not conform. */
export function parseResponse<T>(
	schema: z.ZodType<T>,
	body: unknown,
	route: string,
): T {
	return parseContract(
		schema,
		body,
		(cause) => new BqlContractError(route, cause),
	)
}
